var React = require('react');

function ServicesM (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .s-forms {\n        fill:#F2F2F2;\n      }\n    ")),React.createElement("path",{"id":"s_3","className":"s-forms","d":"M449.34,792.3c97.6-151.07,236.36-199.89,309.93-109s54.08,287-43.51,438-236.36,199.88-309.93,109S351.75,943.37,449.34,792.3Z","key":1}),React.createElement("path",{"id":"s_2","className":"s-forms","d":"M363.15,255.69C482.34,464,526.39,700.17,461.55,783.25s-214-18.41-333.23-226.68S-34.93,112.09,29.92,29,244,47.41,363.15,255.69Z","key":2}),React.createElement("path",{"id":"s_1","className":"s-forms","d":"M634.42,1650c123,222.14,101.29,458.73-48.48,528.43s-370.88-53.89-493.88-276S-9.23,1443.68,140.54,1374,511.42,1427.87,634.42,1650Z","key":3})]);
}

ServicesM.defaultProps = {"id":"services_m","data-name":"services","viewBox":"0 0 803.86 2197.9"};

module.exports = ServicesM;

ServicesM.default = ServicesM;
